<div class="flex flex-col justify-between">
  <h3>Rename "{{ site.name }}"</h3>

  <mat-form-field class="mt-4 w-full">
    <input matInput [(ngModel)]="name" />
  </mat-form-field>

  <div class="flex justify-end items-center gap-2 mt-4">
    <sbnb-button type="secondary" (clicked)="dialogRef.close()">Cancel</sbnb-button>

    <sbnb-button type="primary" [loading]="loading" (clicked)="rename()">Rename</sbnb-button>
  </div>
</div>
